import axios from "axios";
import { useCallback, useEffect, useRef, useState } from "react";
import { useUser } from "../../components/UserContext.js";

export const useFetch = ({
  data,
  endpoint: { headers, method, url },
  mustFetch,
  onFail = () => { },
  onSuccess = () => { },
}) => {
  const { isEmployee, user } = useUser();
  const [result, setResult] = useState(null);
  const [isFetching, setIsFetching] = useState(false);
  const [error, setError] = useState(null);
  const fetchInProgress = useRef(false);

  const fetchData = useCallback(
    async (overrideData, queryParams = '') => {
      if (fetchInProgress.current) return;

      fetchInProgress.current = true;
      setIsFetching(true);
      setError(null);

      try {
        const defaultUrl = queryParams ? `${url}?${queryParams}` : url;
        const urlWithEditor = `${url}?editor=${user?.employee?.id}${queryParams}`;
        // headers is only used in specific calls that don't require sending editor.
        const isEditing = ["POST", "PUT"].includes(method) && !headers;

        const { data: response } = await axios({
          url: isEmployee && isEditing ? urlWithEditor : `${defaultUrl}`,
          method,
          headers,
          data: overrideData || data,
        });

        setResult(response?.data || response);
        onSuccess(response?.data || response);
      } catch (response) {
        const error = response?.response?.data || response;

        setError(error);
        onFail(error);
      } finally {
        fetchInProgress.current = false;
        setIsFetching(false);
      }
    },
    [data, headers, isEmployee, method, onFail, onSuccess, url, user]
  );

  useEffect(() => {
    if (method === "GET" && mustFetch && !error) {
      fetchData();
    }
  }, [data, error, fetchData, method, mustFetch, url]);

  return { result, isFetching, error, fetchData };
};
